// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    SELF_HOSTED_PRODUCTS_REQUEST: null,
    SELF_HOSTED_PRODUCTS_FAILED: null,
    RECEIVED_SELF_HOSTED_PRODUCTS: null,
});
